import React from "react"
import { useTranslation } from "react-i18next"

import { Toggle } from "shared/ui/input/boolean/toggle/Toggle"

import { useProductPositionFormCoreContext } from "../../contexts/ProductPositionFormCoreContext"
import { useProductPositionFormLoadingContext } from "../../contexts/ProductPositionFormLoadingContext"

export const ProductPositionIsAlternativeInput = React.memo(() => {
  const { t } = useTranslation()
  const { isReadonly, isDisabled, formOptions } =
    useProductPositionFormCoreContext()
  const { isLoading } = useProductPositionFormLoadingContext()
  const { hideIsAlternative, isIsAlternativeReadonly } = formOptions || {}

  if (hideIsAlternative) return null

  return (
    <Toggle.Root
      name="productPosition.isAlternative"
      label={t("ProductPosition.isAlternative")}
      loading={isLoading}
      disabled={isDisabled}
      readonly={isReadonly || isIsAlternativeReadonly}
    >
      <div className="toggle-control toggle-control--horizontal">
        <Toggle.Input />
        <Toggle.Label />
        <Toggle.Readonly />
      </div>
      <Toggle.ErrorMessage />
    </Toggle.Root>
  )
})
